module.exports = __webpack_public_path__ + "static/keytruda-dosing-desktop-12ec799da3ff15d2c3d5f8229fdb085c.png";